import React, { useContext } from 'react';
import { StatusBannerContext } from './StatusBannerContext';
import './StatusBanner.css';

const StatusBanner = () => {
  const { bannerMessage, bannerType } = useContext(StatusBannerContext);

  if (!bannerMessage) return null;

  return (
    <div
      className={`status-banner ${bannerType}`}
      role="alert"
      aria-live="assertive"
    >
      {bannerMessage}
    </div>
  );
};

export default StatusBanner;
